import * as yup from 'yup';

import { ErrorMsg } from 'helpers/yup/constants';

import { HALF_NAMES, IPeriodNames, MONTH_NAMES, PERIOD_NAMES, QUARTER_NAMES, YEARS_NAMES } from './periods';

export const quarterValidationSchema = yup.object({
  [QUARTER_NAMES.Q1]: yup.string().required(ErrorMsg.required),
  [QUARTER_NAMES.Q2]: yup.string().required(ErrorMsg.required),
  [QUARTER_NAMES.Q3]: yup.string().required(ErrorMsg.required),
  [QUARTER_NAMES.Q4]: yup.string().required(ErrorMsg.required),
});

export const monthValidationSchema = yup.object({
  [MONTH_NAMES.M1]: yup.string().required(ErrorMsg.required),
  [MONTH_NAMES.M2]: yup.string().required(ErrorMsg.required),
  [MONTH_NAMES.M3]: yup.string().required(ErrorMsg.required),
  [MONTH_NAMES.M4]: yup.string().required(ErrorMsg.required),
  [MONTH_NAMES.M5]: yup.string().required(ErrorMsg.required),
  [MONTH_NAMES.M6]: yup.string().required(ErrorMsg.required),
  [MONTH_NAMES.M7]: yup.string().required(ErrorMsg.required),
  [MONTH_NAMES.M8]: yup.string().required(ErrorMsg.required),
  [MONTH_NAMES.M9]: yup.string().required(ErrorMsg.required),
  [MONTH_NAMES.M10]: yup.string().required(ErrorMsg.required),
  [MONTH_NAMES.M11]: yup.string().required(ErrorMsg.required),
  [MONTH_NAMES.M12]: yup.string().required(ErrorMsg.required),
});

export const halfValidationSchema = yup.object({
  [HALF_NAMES.H1]: yup.string().required(ErrorMsg.required),
  [HALF_NAMES.H2]: yup.string().required(ErrorMsg.required),
  [HALF_NAMES.H3]: yup.string().required(ErrorMsg.required),
  [HALF_NAMES.H4]: yup.string().required(ErrorMsg.required),
  [HALF_NAMES.H5]: yup.string().required(ErrorMsg.required),
  [HALF_NAMES.H6]: yup.string().required(ErrorMsg.required),
});

export const yearValidationSchema = yup.object({
  [YEARS_NAMES.Y1]: yup.string().required(ErrorMsg.required),
  [YEARS_NAMES.Y2]: yup.string().required(ErrorMsg.required),
  [YEARS_NAMES.Y3]: yup.string().required(ErrorMsg.required),
  [YEARS_NAMES.Y4]: yup.string().required(ErrorMsg.required),
  [YEARS_NAMES.Y5]: yup.string().required(ErrorMsg.required),
});

export const periodSchemas = {
  [PERIOD_NAMES.QUARTER_VALUES]: quarterValidationSchema,
  [PERIOD_NAMES.MONTH_VALUES]: monthValidationSchema,
  [PERIOD_NAMES.HALF_VALUES]: halfValidationSchema,
  [PERIOD_NAMES.YEAR_VALUES]: yearValidationSchema,
};

// TODO: remove
export const getPeriodValidationSchema = (period: IPeriodNames) => {
  if (period) {
    return periodSchemas[period];
  }
  return yup.object();
};

export const getArrayPeriodValidation = (periodName: string) => {
  return yup
    .array()
    .when(periodName, (period, schema) => {
      const periodSchema = getPeriodValidationSchema(period[0]);
      return schema.of(periodSchema).required(ErrorMsg.required);
    })
    .required(ErrorMsg.required);
};
